import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCompress,
  faClosedCaptioning,
  faExpand,
  faPause,
  faPlay,
  faPlayCircle,
  faSpinner,
  faVolumeDown,
  faVolumeMute,
  faVolumeOff,
  faVolumeUp,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faClosedCaptioning,
  faCompress,
  faExpand,
  faPause,
  faPlay,
  faPlayCircle,
  faSpinner,
  faVolumeDown,
  faVolumeMute,
  faVolumeOff,
  faVolumeUp
)
